
import analytics from '@/mixins.js/analytics'
import { formatPrice } from '@/utils/helpers'
export default {
  filters: { formatPrice },
  mixins: [analytics],
  props: {
    item: { type: Object, required: true },
    listPosition: { type: Number, required: true },
    listName: { type: String, required: true }
  },
  data () {
    return {
      showModal: false,
      addingToCart: false,
      removing: false,
      relatedDiagrams: []
    }
  },
  methods: {
    async addToCart () {
      this.addingToCart = true
      await this.$store.dispatch('checkout/addDiagramToCart', { diagram: this.diagram, $gtag: this.$gtag, $matomo: this.$matomo, $bing: this.$bing })
      await this.$store.dispatch('checkout/showAddedToCartModal', { diagram: this.diagram, $backend: this.$backend })
      this.addingToCart = false
    },
    async removeFromWishlist () {
      this.removing = true
      await this.$store.dispatch(
        'favourites/removeFavourite',
        {
          diagram: this.item.diagram,
          $backend: this.$backend,
          $gtag: this.$gtag
        })
      this.removing = false
    }
  }
}
